import Reportes from './Reportes'
import VentasPorRango from './VentasPorRango'
import ProductosMasVendidos from './ProductosMasVendidos'
import CategoriasMasVendidas from './CategoriasMasVendidas'

export default Reportes
export { VentasPorRango, ProductosMasVendidos, CategoriasMasVendidas }
